export default {
  ASSETS_TO_BE_DEPLOYED: "0xbA53a278D6d68c2C8F6d600eA93581a702A6006A",
  ONCHAIN_WALLETS: "0x7C819F438250CD9331D3E8EA540B72B3FF702f07",
  AVAILABLE_LIQUIDITY_BUFFER: "0x910CA844Fb578f670Ca5190c1cF4ab851155Bf99",
}
